import React from "react";
import "./styles.css";
import Header from "../Header/Header";
import SideBar from "../SideBar";
import EnvironmentStatusBar from "../EnvironmentStatus/EnvironmentStatusBar/EnvironmentStatusBar";
const DashboardLayout = ({ isTokenReady, children }) => {
  return isTokenReady ? (
    <div className="dashboard">
      <header>
        <Header />
        <EnvironmentStatusBar />
      </header>
      <div className="dashboard-main">
        <SideBar />
        <div className="content">{children}</div>
      </div>
    </div>
  ) : null;
};
export default DashboardLayout;
